import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import lottie from 'lottie-web/build/player/lottie_light';
import { onMounted, ref, onBeforeUnmount, nextTick } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderAnim',
  props: {
  name: {
    type: String,
    required: true
  },
  rawAnimData: {
    type: Object,
    required: true,
  }
},
  setup(__props) {

let curProportion = 0;
let anim: any; // lottie animation

const props = __props

const headerAnim = ref<HTMLDivElement>(null)

onMounted(() => {
  windowWidthListener(null, true)
  nextTick(() => {
    window.addEventListener('resize', windowWidthListener)
  })
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', windowWidthListener)
})

function getImageProportion(width: number) {
  if (width > 2200)
    return 4
  else if (width > 1195)
    return 2
  return 1
}

function windowWidthListener(evt: Event | null, first = false) {
  const newVal = window.innerWidth
  const newProportion = getImageProportion(newVal)
  console.log(`newVal: ${ newVal } newProportion: ${ newProportion }`)
  if (!curProportion || newProportion > curProportion) {
    loadAnimation(newProportion, first)
  }
  curProportion = newProportion
}

// check_webp_feature:
//   'feature' can be one of 'lossy', 'lossless', 'alpha' or 'animation'.
//   'callback(feature, isSupported)' will be passed back the detection result (in an asynchronous way!)
function check_webp_feature(feature): Promise<boolean> {
  return new Promise(callback => {
    const kTestImages = {
        // lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
        // lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
        alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
    };
    const img = new Image();
    img.onload = function () {
        const result = (img.width > 0) && (img.height > 0);
        callback(result);
    };
    img.onerror = function () {
        callback(false);
    };
    img.src = "data:image/webp;base64," + kTestImages[feature];
  })
}

// this is pretty slow (~300ms in Chrome as of 2/12/2022)
check_webp_feature('alpha').then((res) => {
  // fallback to png
  if (!res)
    loadAnimation(curProportion, false, false);
});


function loadAnimation(proportion: number, first = false, webp = true) {
  console.log('reloading anim with ' + proportion)
  if (anim)
    anim.destroy()

  if (!window.__PRERENDER_INJECTED?.isPrerendering) {
    const animationData = {
      ...props.rawAnimData,
      assets: props.rawAnimData.assets.map(asset => {
        if (asset.u)
          return {
            ...asset,
            u: `/anim-v4/${asset.u.replace('/', `_${proportion}x/`)}`,
            p: `${asset.p.slice(0, -3)}${webp ? 'webp' : 'png'}`,
          }
        return asset;
      })
    };

    anim = lottie.loadAnimation({
      container: headerAnim.value,
      // path: `/assets/anim/${ props.name }${ proportion > 1 ? '-' + proportion + 'x' : '' }.json`,
      animationData,
      renderer: 'svg',
      loop: true,
      autoplay: true,
    })
  }

  // if (first) {
  //   // hack to clear initial frame
  //   anim.addEventListener('data_ready', () => {
  //     console.log('clearing shits')
  //     // headerAnim.value.removeChild(headerAnim.value.firstChild!)
  //   })
  // }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", {
    ref_key: "headerAnim",
    ref: headerAnim
  }, null, 512))
}
}

})